import { supabase } from '../../shared/supabase/supabaseClient';

export type AwaitingInvitationResult = {
  ok: boolean;
  /** Código del servidor: `already_owner`, `no_active_org`, `has_orders`, … */
  code: string | null;
  message: string | null;
};

function readResult(raw: unknown, fallbackMessage: string): AwaitingInvitationResult {
  const body = (raw ?? {}) as { ok?: boolean; error?: string; message?: string };
  if (body.ok === true) {
    return { ok: true, code: null, message: typeof body.message === 'string' ? body.message : null };
  }
  return {
    ok: false,
    code: typeof body.error === 'string' ? body.error : null,
    message: typeof body.message === 'string' ? body.message : fallbackMessage,
  };
}

/**
 * Marca (o saca) la intención de esperar una invitación de empleado.
 * El servidor rechaza con `already_owner` si la cuenta ya tiene un negocio activo.
 */
export async function setAwaitingEmployeeInvitation(
  awaiting: boolean,
): Promise<AwaitingInvitationResult> {
  const { data, error } = await supabase.rpc('set_awaiting_employee_invitation', {
    p_awaiting: awaiting,
  });
  if (error) {
    return { ok: false, code: null, message: error.message || 'No pudimos guardar el cambio.' };
  }
  return readResult(data, 'No pudimos guardar el cambio.');
}

/**
 * Cierra el negocio propio si está vacío (sin pedidos, turnos ni empleados) y
 * deja la cuenta esperando invitación.
 */
export async function abandonEmptyOwnedOrganization(): Promise<AwaitingInvitationResult> {
  const { data, error } = await supabase.rpc('abandon_empty_owned_organization');
  if (error) {
    return { ok: false, code: null, message: error.message || 'No pudimos cerrar el negocio.' };
  }
  return readResult(data, 'No pudimos cerrar el negocio.');
}
